import { InjectionToken } from '@angular/core';
import { CategoryNaturalKey } from '.';
import { FilterFieldValue } from '../covance-filter';

export interface FilterResolver {
    resolveFilters(categoryKey: CategoryNaturalKey): FilterFieldValue[];
}

export const FILTER_RESOLVER = new InjectionToken<FilterResolver>('FilterResolverForFilteredGrid');
